export const program = {
  noEligibleUsers: 'Disculpe, no hay miembros elegibles para este programa.',
  title: {
    selectToStart: 'Seleccione para comenzar',
    selectUser: 'Por favor, selecciona un miembro para acceder a sus recursos.',
    activeMembers: 'Miembros activos',
  },
  subtitle: {
    accessProgram: 'Accede a los recursos del programa y gestiona la suscripción',
  },
  action: {
    goBack: 'Volver a casa',
  },
  error: {
    failedToLoadProviders: 'No se pudieron cargar los proveedores',
    failedToLoadPatients: 'No se pudieron cargar los pacientes.',
    failedToScheduleConsultation: 'Error al programar la consulta',
    failedToBookAppointment: 'No se pudo reservar la cita',
    failedToGetProgram: 'No se pudo obtener el programa',
    failedToProcessFlow: 'No se pudo procesar el flujo',
    filedToRemoveReservation: 'No se pudo eliminar la reserva',
    failedToSheduleAppointment: 'No se pudo programar la cita',
  },
};
